import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import { Select, MenuItem, Checkbox } from '@mui/material';
import { Modal } from '../../../components/BootstrapToMUI';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { languages, languages_noEn } from '../../../staticData/languages';

import { useForm, Controller } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  formControl: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function CreateLabel(props) {
  const classes = useStyles();
  const { name, update, referTo, id, reflesh, setReflesh, ...rest } = props;

  const title = update ? 'Update' : 'Add New';
  const user = JSON.parse(localStorage.getItem('user'));

  const advanced = user?.features?.advanced;
  const langs = user?.langs;
  const [langArray, setlangArray] = useState([]);
  const [enArray, setenArray] = useState([]);

  let defaultValues = {
    select: 'en',
    name: '',
    autoTrans: false,
  };

  const {
    reset,
    watch,
    handleSubmit,
    register,
    clearErrors,
    setError,
    control,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const watchAll = watch();

  const onSubmit = (formData) => {
    const myData = new FormData();
    let name = { en: formData.name };
    langArray.forEach((e) => {
      if (formData[e.code + 'Name'] != '') {
        name[e.code] = formData[e.code + 'Name'];
      }
    });
    myData.append('name', JSON.stringify(name));
    myData.append('referTo', referTo);
    myData.append('auto', formData.autoTrans);
    if (langs?.length > 0) {
      langs.forEach((e) => {
        myData.append('langs', e);
      });
    }
    console.log('myData', myData);
    if (update) {
      request({
        method: 'put',
        url: `${process.env.REACT_APP_SERVER_API}/labels/edit/${id}`,
        data: myData,
      })
        .then((res) => {
          props.onHide();
          Swal.fire({
            text: `The label has been successfully updated: ${formData.name}`,
            icon: 'success',
          }).then(() => {
            reflesh ? setReflesh(false) : setReflesh(true);
          });
        })
        .catch((err) => {
          Swal.fire({
            text: err.response?.data?.error,
            icon: 'error',
          });
        });
    } else {
      request({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER_API}/labels/create`,
        data: myData,
      })
        .then((res) => {
          props.onHide();
          Swal.fire({
            text: `New label has been successfully created: ${formData.name}`,
            icon: 'success',
          }).then(() => {
            reflesh ? setReflesh(false) : setReflesh(true);
          });
        })
        .catch((err) => {
          Swal.fire({
            text: err.response?.data?.error,
            icon: 'error',
          });
        });
    }
  };

  useEffect(() => {
    let a1 = [];
    let a2 = [languages[0]];
    if (langs?.length > 0) {
      langs.forEach((lan) => {
        const index = languages_noEn.findIndex((e) => e.code === lan);
        if (index > -1) {
          a1.push(languages_noEn[index]);
          a2.push(languages_noEn[index]);
        }
      });
    }

    console.log('language A1', a1);
    setlangArray(a1);
    setenArray(a2);
    a1.forEach((e) => {
      defaultValues[e.code + 'Name'] = '';
    });

    if (update) {
      let resetObj = {
        select: 'en',
        name: name.en,
      };
      for (const property in name) {
        resetObj[property + 'Name'] = name[property];
      }
      reset(resetObj);
    } else {
      reset(defaultValues);
    }
  }, [props.show]);

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title} Label</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main">
          <CssBaseline />
          <div className={classes.paper}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={advanced ? 7 : 12}>
                  <Controller
                    render={({ field }) => (
                      <Select fullWidth defaultValue="en" {...field} variant="outlined">
                        {enArray.map((e) => {
                          return <MenuItem value={e.code}>{e.name}</MenuItem>;
                        })}
                      </Select>
                    )}
                    name="select"
                    control={control}
                  />
                </Grid>
                {advanced && (
                  <Grid
                    item
                    xs={5}
                    style={{
                      display: 'flex',
                      alignContent: 'center',
                      alignItems: 'center',
                      fontSize: '16px',
                    }}
                  >
                    <Controller
                      name="autoTrans"
                      control={control}
                      render={({ field }) => <Checkbox {...field} />}
                    />
                    <span>Auto Translate</span>
                  </Grid>
                )}

                <Grid item xs={12} hidden={watchAll.select !== 'en'}>
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: 'name is required' }}
                    render={({ field }) => (
                      <TextField
                        label="name"
                        variant="outlined"
                        inputProps={{
                          maxLength: '30',
                        }}
                        required
                        fullWidth
                        {...field}
                      />
                    )}
                  />
                </Grid>

                {langArray.map((e) => {
                  return (
                    <Grid item xs={12} hidden={watchAll.select !== e.code}>
                      <Controller
                        name={e.code + 'Name'}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="name"
                            variant="outlined"
                            required
                            inputProps={{
                              maxLength: '30',
                            }}
                            fullWidth
                            {...field}
                          />
                        )}
                      />
                    </Grid>
                  );
                })}
                {errors.name && (
                  <p className="signUpErrorMessage" style={{ marginLeft: '10px' }}>
                    {errors.name.message}
                  </p>
                )}
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit
              </Button>
            </form>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
